import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

import 'swiper/css';
import './teaser-slider.scss';

class TeaserSlider {
    constructor ($element) {
        this.$teaserSlider = $element;
        this.$teaserSliderContainer = this.$teaserSlider.querySelector('[data-teaser-slider="slider"]');
        this.$$teaser = this.$teaserSlider.querySelectorAll('[data-teaser-slider="teaser"]');
        this.teaserSliderSlider = null;
        this.openSlide = null;
    }

    initialize () {
        if (this.$$teaser.length > 1) {
            this.initSlider();
        }

        if (this.$$teaser.length > 0) {
            this.$$teaser.forEach($teaserSlide => {
                $teaserSlide.onclick = () => {
                    this.closeSlides();

                    this.openSlide = $teaserSlide;
                    $teaserSlide.setAttribute('aria-pressed', 'true');
                };
            });

            this.handleOutClick();
        }
    }

    initSlider () {
        const prevBTN = this.$teaserSlider.querySelector('[data-slider-prev]');
        const nextBTN = this.$teaserSlider.querySelector('[data-slider-next]');

        this.teaserSliderSlider = new Swiper(this.$teaserSliderContainer, {
            modules: [Navigation, A11y],
            speed: 400,
            spaceBetween: 16,
            effect: 'fade',
            slidesPerView: 'auto',
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide'
            },
            navigation: {
                prevEl: prevBTN,
                nextEl: nextBTN,
                addIcons: false,
            },
            breakpoints: {
                768: {
                    spaceBetween: 40
                }
            }
        });
    }

    handleOutClick () {
        document.onclick = (e) => {
            const $closestTeaserSlide = e.target.closest('[data-teaser-slider="teaser"]');

            if (!$closestTeaserSlide && this.openSlide !== null) {
                this.closeSlides();
            }
        };

        document.onkeydown = (e) => {
            if (e.key === 'Escape') {
                if (this.openSlide !== null) {
                    this.closeSlides();
                }
            }

            if (e.key === 'Tab') {
                const $closestTeaserSlide = e.target.closest('[data-teaser-slider="teaser"]');

                if (!$closestTeaserSlide && this.openSlide !== null) {
                    this.closeSlides();
                }
            }
        };
    }

    closeSlides () {
        this.openSlide = null;

        this.$$teaser.forEach($teaserSlide => {
            $teaserSlide.setAttribute('aria-pressed', 'false');
        });
    }
}

export { TeaserSlider };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$TeaserSlider = $context.querySelectorAll('[data-teaser-slider="root"]');

        for (let i = 0; i < $$TeaserSlider.length; i++) {
            const $TeaserSlider = $$TeaserSlider[i];
            const TeaserSliderAPI = new TeaserSlider($TeaserSlider);
            TeaserSliderAPI.initialize();
        }
    }
});
